// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._72pfOCwxlaD68L2dENk-pw\\=\\=,.simple-pagination{margin-top:12px;text-align:right}._72pfOCwxlaD68L2dENk-pw\\=\\= span,.simple-pagination span{cursor:pointer}", "",{"version":3,"sources":["/app/client_react/src/components/Shared/Pagination/SimplePagination.styl"],"names":[],"mappings":"AAEA,gDAEE,eAAY,CACZ,gBAAY,CAEZ,0DACE,cAAQ","file":"SimplePagination.styl","sourcesContent":["@import '../../../../../client/styles/vars';\n\n:local(.global),\n.simple-pagination {\n  margin-top: 12px;\n  text-align: right;\n\n  span {\n    cursor: pointer;\n  }\n}\n"]}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"global": "_72pfOCwxlaD68L2dENk-pw=="
};
module.exports = ___CSS_LOADER_EXPORT___;
